import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormGroup, FormControl, TextField, Button } from '@mui/material';
import createAxiosInstance from '../../../../api';
import { useAlert } from '../../../../components/Notification';
import { useForm } from 'react-hook-form';

// type FormName = 'roleName' | 'permission';

const CreateRole = () => {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const { name, id } = useParams();
  const showAlert = useAlert();
  // const [formData, setFormData] = useState({ roleName: name ? name : '' });
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm({ defaultValues: { roleName: name || '' } });
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string>
  >({});

  // const handleFormData = (formName: FormName, formValue: string[] | string) => {
  //   let updatedValue: string[] | string;

  //   if (typeof formValue === 'string') {
  //     if (formValue.length < 1) {
  //       setValidationErrors({
  //         ...validationErrors,
  //         roleName: 'Role Name is required',
  //       });
  //     } else {
  //       setValidationErrors({ ...validationErrors, roleName: '' });
  //     }
  //     const form_Data = { ...validationErrors };
  //     delete form_Data.roleName;
  //     setValidationErrors(form_Data);
  //     updatedValue = formValue;
  //   } else {
  //     if (formValue.length < 1) {
  //       setValidationErrors({
  //         ...validationErrors,
  //         permission: 'Assign Permission is required',
  //       });
  //     } else {
  //       setValidationErrors({ ...validationErrors, permission: '' });
  //     }
  //     const form_Data = { ...validationErrors };
  //     delete form_Data.permission;
  //     setValidationErrors(form_Data);
  //     updatedValue = formValue;
  //   }
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [formName]: updatedValue,
  //   }));
  // };

  const validateForm = (data: any) => {
    const errors: Record<string, string> = {};

    if (data.roleName.trim() === '') {
      errors.roleName = 'Role Name is required';
    }

    const regex = /^[a-zA-Z0-9_ -]+$/;

    if (data.roleName.length > 0) {
      if (!regex.test(data.roleName)) {
        errors.roleName = 'Special character not allowed';
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submitedData = (data: any) => {
    const isValid = validateForm(data);

    if (isValid) {
      const url = id ? '/updateRole' : '/createRole';
      const payload = id
        ? { roleName: data.roleName, roleID: id }
        : { roleName: data.roleName };
      axiosInstance
        .post(url, payload)
        .then(() => {
          showAlert('Role Create Successful', 'success');
          navigate('/iam/role');
        })
        .catch(() => {
          showAlert('Failed Role Create', 'warning');
        });
    }
  };

  return (
    <div className="form-role_management">
      <form onSubmit={handleSubmit(submitedData)}>
        <FormControl className="w-100">
          <div className="form-item w-100">
            <div className="form-item-label">
              <h6>
                <b>Role Name</b>
              </h6>
              <p className="m-0">
                Will appear on other profile and other communications
              </p>
            </div>
            <div className="form-item-input">
              <FormGroup>
                <TextField
                  // value={formData.roleName}
                  id="rolename"
                  variant="outlined"
                  fullWidth
                  {...register('roleName', { required: true })}
                  onChange={(e) => {
                    setValidationErrors({});
                    clearErrors('roleName');
                    // handleFormData('roleName', e.target.value as string)
                  }}
                  error={
                    validationErrors.roleName || errors.roleName ? true : false
                  }
                />
                {errors.roleName && (
                  <span className="text-danger">Role Name is required</span>
                )}
                {validationErrors.roleName && (
                  <span className="text-danger">
                    {validationErrors.roleName}
                  </span>
                )}
              </FormGroup>
            </div>
          </div>
        </FormControl>
        <hr />
        <div className="submit-btn d-flex justify-content-end">
          <Button
            color="primary"
            type="submit"
            // onClick={() => {
            //   // submitedData();
            // }}
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateRole;
